module.exports = __webpack_public_path__ + "static/media/(010121).6e72a95c.jpg";